import React, { useMemo } from 'react';
import { InvoiceData, InvoiceSettings } from '../../types';
import { TRANSLATIONS } from '../../constants';
import TemplateDispatcher from './Templates/Dispatcher';

interface Props {
  data: InvoiceData;
  settings: InvoiceSettings;
}

const InvoiceTemplate: React.FC<Props> = ({ data, settings }) => {
  const labels = TRANSLATIONS[settings.language] || TRANSLATIONS['en'];

  const subtotal = useMemo(
    () => data.items.reduce((acc, i) => acc + i.quantity * i.rate, 0),
    [data.items]
  );
  const taxTotal = useMemo(
    () => data.items.reduce((acc, i) => acc + i.quantity * i.rate * (i.tax / 100), 0),
    [data.items]
  );
  const total = subtotal + taxTotal;

  return (
    <div className="print-container">
      <TemplateDispatcher
        data={data}
        settings={settings}
        labels={labels}
        subtotal={subtotal}
        taxTotal={taxTotal}
        total={total}
      />
    </div>
  );
};

export default InvoiceTemplate;
